import { countryFormats } from '~/helpers/countryFormats'

const countryCodeMap: Record<string, string> = {}

Object.entries(countryFormats).forEach(([countryCode, data]) => {
  const numericCode = data.code.replace(/\D/g, '')
  countryCodeMap[numericCode] = countryCode
})

const detectCountry = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, '')

  const sortedCodes = Object.keys(countryCodeMap).sort(
    (a, b) => b.length - a.length
  )

  for (const code of sortedCodes) {
    if (cleaned.startsWith(code)) {
      return countryCodeMap[code]
    }
  }

  return 'RU'
}

export const formatPhoneByCountry = (phone: string): string => {
  if (!phone) return ''

  const cleaned = phone.replace(/\D/g, '')
  const countryCode = detectCountry(phone)
  const format =
    (
      countryFormats as Record<
        string,
        { code: string; mask: string; icon: string }
      >
    )[countryCode]?.mask || countryFormats['RU'].mask

  let result = ''
  let digitIndex = 0

  for (const char of format) {
    if (char === '#') {
      if (digitIndex < cleaned.length) {
        result += cleaned[digitIndex]
        digitIndex++
      } else {
        break
      }
    } else {
      result += char
    }
  }

  return result
}
